module.exports = __webpack_public_path__ + "static/WFTPM-b4640fad4baa9a8c986d6ff0539f8215.png";